import axios from 'axios'
import config from '../config'
import {
    Message
} from 'element-ui';
import {
    startLoading,
    endLoading
} from '../processing'
import {
    handleError
} from '../index'
import cookie from 'js-cookie'
import quit from '@/common/quit.js'
axios.defaults.baseURL = config.baseURL

function authHeader() {
    return {
        'x-auth-token': cookie.get('token'),
    }
}

let base64 = ''
// const handleError = (error) => {
//     let response = error.response
//     if (response && (response.status == 401 || response.status == 403)) {
//         quit()
//     } else {
//         if (response && error.response.data) {
//             Message.error(error.response.data.message)
//         } else {
//             Message.error(error.toString())
//         }
//     }
// }
export default {
    getMedicalEstablishmentList: async (params, userType) => {
        startLoading();
        try {
            let url = ''
            if (userType === 'ROLE_AGENT') {
                url = '/agent/station'
            } else if (userType === 'ROLE_REGION_MANAGER') {
                params.sort = 'createdAt,DESC'
                params.size = 20
                url = '/region/station/review'
            } else if (userType === 'ROLE_SUPER_ADMIN') {
                params.sort = 'createdAt,DESC'
                params.size = 20
                url = '/group/station'
            }
            let result = await axios.get(url, {
                params: params,
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    agentAddStation: async (data) => {
        startLoading();
        try {
            await axios.post('/agent/station', data, {
                headers: authHeader()
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getAgentInfoById: async (data) => {
        startLoading();
        try {
            const result = await axios.get(`/agent/${data}`, {
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    AddNewAgent: async (data) => {
        startLoading();
        try {
            await axios.post('/agent', data, {
                headers: authHeader()
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    AddMyAgent: async (data) => {
        startLoading();
        try {
            await axios.post('/agent/my', data, {
                headers: authHeader()
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    AddNewAgentManageRange: async (data) => {
        startLoading();
        try {
            await axios.post('/agent/district', data, {
                headers: authHeader()
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    agentApplyStation: async (data) => {
        startLoading();
        try {
            await axios.post('/agent/station/apply', data, {
                headers: authHeader()
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    agentStationEmployeeList: async (stationId, type, params) => {
        startLoading();
        try {
            params.sort = 'createdAt,DESC'
            // params.size = 20
            const result = await axios.get(`/station/${stationId}/${type}`, {
                params: params,
                headers: authHeader()
            })
            endLoading()
            return result.data

        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    agentStationSubordinateEmployeeList: async () => {
        startLoading();
        try {
            let params = {
                size: 200
            }
            const result = await axios.get(`/agent/subordinate?roles=ROLE_AGENT_OPTOMETRIST&roles=ROLE_DOCTOR&roles=ROLE_STATION_MANAGER`, {
                headers: authHeader(),
                params
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    updateAgenteEmployeeAuthorized: async (type, data) => {
        startLoading();
        try {
            if (type === 'add') {
                await axios.post('/agent/station/subordinate', data, {
                    headers: authHeader()
                })
            } else if (type === 'remove') {
                await axios.delete('/agent/station/subordinate', {
                    data: data,
                    headers: authHeader()
                }, )
            }

            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    regionEditAgent: async (data) => {
        startLoading();
        try {
            await axios.put('/region/agent', data, {
                headers: authHeader()
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    regionEditAgentManageRange: async (data) => {
        startLoading();
        try {
            await axios.put('/agent/district/auth', data, {
                headers: authHeader()
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            // handleError(error)
            return error.response.data.message
        }
    },
    GetRefundList: async (params) => {
        startLoading();
        try {
            const result = await axios.get('/patient/treatment/refund/list', {
                params: params,
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    GetSalesPerformance: async (params) => {
        startLoading();
        try {
            const result = await axios.get('/agent/subordinate/sales/performance', {
                params: params,
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    GetSalesPerformanceDetail: async (subordinateId, params) => {
        startLoading();
        try {
            const result = await axios.get(`/agent/subordinate/${subordinateId}/sales/performance`, {
                params: params,
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    GetGameSalesDetail: async(params) => {
        startLoading();
        try {
            const result = await axios.get("/game/sales", {
                params: params,
                headers: authHeader()
            })
            endLoading();
            return result.data;
        } catch (e) {
            endLoading()
            handleError(error)
        }
    },
    GetStationSalesPerformance: async (params) => {
        startLoading();
        try {
            const result = await axios.get('/station/sales/performance', {
                params: params,
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    GetStationSalesPerformanceLastDays: async (params) => {
        startLoading();
        try {
            const result = await axios.get('/station/sales/performance/month', {
                params: params,
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    GetStationSalesPerformanceLastMonths: async (params) => {
        startLoading();
        try {
            const result = await axios.get('/station/sales/performance/year', {
                params: params,
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    GetStationMonthlyStatistics: async (params) => {
        startLoading();
        try {
            const result = await axios.get('/sales/statistics/station/monthly', {
                params: params,
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    GetStationMonthlyStatisticsExport: async (params) => {
        startLoading();
        try {
            const result = await axios.get('/sales/statistics/station/monthly/export', {
                params: params,
                responseType: "blob",
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    GetStationDailyStatistics: async (params) => {
        startLoading();
        try {
            const result = await axios.get('/sales/statistics/station/daily', {
                params: params,
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    GetStationDailyStatisticsExport: async (params) => {
        startLoading();
        try {
            const result = await axios.get('/sales/statistics/station/daily/export', {
                params: params,
                responseType: "blob",
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    GetStationSalesDetails: async (params) => {
        startLoading();
        try {
            const result = await axios.get('/sales/statistics/station/records', {
                params: params,
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    GetStationSalesDetailsExport: async (params) => {
        startLoading();
        try {
            const result = await axios.get('/sales/statistics/station/records/export', {
                params: params,
                responseType: "blob",
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    GetStationSalesPerformanceDetail: async (stationUUID, params) => {
        startLoading();
        try {
            const result = await axios.get(`/station/${stationUUID}/sales/performance`, {
                params: params,
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getAgentAchievementStatistic: async () => {
        startLoading();
        try {
            const result = await axios.get(`/agent/achievement/statistic`, {
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    // getAgentStatistic: async (params, isStation) => {
    //     startLoading();
    //     try {
    //         let Url = '/agent/statistic'
    //         if (isStation) {
    //             Url = '/agent/statistic/station'
    //         }
    //         const result = await axios.get(Url, {
    //             params,
    //             headers: authHeader()
    //         })
    //         endLoading()
    //         return result.data
    //     } catch (error) {
    //         endLoading()
    //         handleError(error)
    //     }
    // },
    updateStaffDirector: async (data) => {
        startLoading();
        try {
            await axios.put('/agent/station/director', data, {
                headers: authHeader()
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    editHospitalPrice: async (data, stationUUID) => {
        startLoading();
        try {
            await axios.put(`/agent/station/${stationUUID}`, data, {
                headers: authHeader()
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
}


// WEBPACK FOOTER //
// ./src/http/componentsAPI/agent.js